import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatSliderModule } from "@angular/material/slider";
import { MatTooltipModule } from "@angular/material/tooltip";

import { LeafletModule } from "@bluehalo/ngx-leaflet";
import { LeafletDrawModule } from "@bluehalo/ngx-leaflet-draw";
import { LeafletMarkerClusterModule } from "@bluehalo/ngx-leaflet-markercluster";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenDialogModule } from "../../shared/modules/loren-dialog/loren-dialog.module";
import { LorenEntityFormModule } from "../../shared/modules/loren-entity-form/loren-entity-form.module";
import { LorenLayerSelectionModule } from "../../shared/modules/loren-layer-selection/loren-layer-selection.module";
import { LorenLocationFilterModule } from "../../shared/modules/loren-location-filter/loren-location-filter.module";
import { LorenPeriodSelectorModule } from "../../shared/modules/loren-period-selector/loren-period-selector.module";
import { LorenPeriodSelectorFormModule } from "../../shared/modules/loren-period-selector-form/loren-period-selector-form.module";
import { LorenSharedDirectivesModule } from "../../shared/directives/loren-shared-directives.module";
import { LorenAllAssetResolver } from "../loren-assets/resolvers/loren-asset-all.resolver";
import { LorenTraceAssetSelectorDialogComponent } from "./components/loren-trace-asset-selector-dialog/loren-trace-asset-selector-dialog.component";
import { LorenTraceColorSelectorDialogComponent } from "./components/loren-trace-color-selector-dialog/loren-trace-color-selector-dialog.component";
import { LorenTracePeriodSelectorDialogComponent } from "./components/loren-trace-period-selector-dialog/loren-trace-period-selector-dialog.component";
import { LorenMapTracesComponent } from "./components/loren-map-traces/loren-map-traces.component";
import { LorenTraceFeatureSelectorDialogComponent } from "./components/loren-trace-feature-selector-dialog/loren-trace-feature-selector-dialog.component";
import { LorenTracesRoutingModule } from "./loren-traces-routing.module";
import { LorenTraceDialogComponent } from "./components/loren-trace-dialog/loren-trace-dialog.component";
import { LorenPageContentComponent } from "../../shared/modules/loren-page-content/loren-page-content.component";
@NgModule({
  declarations: [
    LorenMapTracesComponent,
    LorenTraceAssetSelectorDialogComponent,
    LorenTraceColorSelectorDialogComponent,
    LorenTracePeriodSelectorDialogComponent,
    LorenTraceFeatureSelectorDialogComponent,
    LorenTraceDialogComponent,
  ],
  providers: [LorenAllAssetResolver],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatSelectModule,
    MatSliderModule,
    MatTooltipModule,

    LeafletModule,
    LeafletDrawModule,
    LeafletMarkerClusterModule,
    TranslocoModule,

    LorenDialogModule,
    LorenEntityFormModule,
    LorenLayerSelectionModule,
    LorenLocationFilterModule,
    LorenPeriodSelectorFormModule,
    LorenPeriodSelectorModule,
    LorenSharedDirectivesModule,
    LorenTracesRoutingModule,

    LorenPageContentComponent,
  ],
})
export class LorenTracesModule {}
